<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6> 

                <v-autocomplete
                  label="Project Name"
                  item-text="project_name"
                  item-value="id"
                  v-model="formSchema.project_id"
                  :items="operationActivitiesList"
                  :rules="[v => !!v || 'Project name is required !']"
                  required
                ></v-autocomplete>
                
              </v-flex>

              <v-flex xs12 sm6 md6>   
                <v-autocomplete
                  label="Development Partner"
                  item-text="dev_partner_name"
                  item-value="id"
                  v-model="formSchema.dev_partner_id"
                  :items="devPartnerList"
                  :rules="[v => !!v || 'Development partner is required !']"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    operationActivitiesList:[],
    devPartnerList:[],    
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Agency Details"
        : "Add Agency Details";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },

  created() {
    commonService.getAllData("get-agency-det-dropdown-data").then(res => {
      this.devPartnerList = res.DevelopmentPartner;
      this.operationActivitiesList = res.OperationActivities;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(formSchema, "agency-details")
            .then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(formSchema, "agency-details")
            .then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
            });
        }
      }
    },

    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {            
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/agency_details/insertForm.vue